export const VIDEO_GUIDES_YOUTUBE_CODES = {
  ETC: { id: 'lgj_6lxg1Ng', start: 909 },
  RVN: { id: '6pBU9eCuiBg', start: 40 },
};

export const TUTORIAL_LINKS = {
  BTC: 'https://hiveon.com/knowledge-base/hiveon-pool/how-to-start-mining-on-hiveon-btc-pool/',
  GRAM: 'https://hiveon.com/knowledge-base/hiveon-pool/how-to-start-mining-on-hiveon-gram-pool/',
};
